import React, { memo, useEffect, useState } from 'react';
import { Typography } from '@/components/novoville';
import { translate, translatePOIType } from '../../services/TranslationService';
import MyCityListItem from './MyCityListItem';

const FiltersComponent = ({
  isMobile,
  pois = [],
  reports = [],
  activeFilters = [],
  filtersChanged,
  clearFilters,
}) => {
  const [availableFilters, setAvailableFilters] = useState([
    { name: 'REPORTS', translatedName: translate('Reports'), value: 0 },
    {
      name: 'PUBLIC_BUILDING',
      translatedName: translatePOIType('PUBLIC_BUILDING'),
      value: 0,
    },
    { name: 'MUSEUM', translatedName: translatePOIType('MUSEUM'), value: 0 },
    {
      name: 'LANDMARK',
      translatedName: translatePOIType('LANDMARK'),
      value: 0,
    },
    {
      name: 'PHARMACY',
      translatedName: translatePOIType('PHARMACY'),
      value: 0,
    },
    {
      name: 'GAS_STATION',
      translatedName: translatePOIType('GAS_STATION'),
      value: 0,
    },
    { name: 'POLICE', translatedName: translatePOIType('POLICE'), value: 0 },
    {
      name: 'ADOPT_A_TREE',
      translatedName: translatePOIType('ADOPT_A_TREE'),
      value: 0,
    },
  ]);

  const [availableReportsFilters, setAvailableReportsFilters] = useState([]);

  useEffect(() => {
    if (!pois || !reports) {
      return;
    }

    // Count POIs by type
    const countMap = pois.reduce((acc, poi) => {
      acc[poi.type] = (acc[poi.type] || 0) + 1;
      return acc;
    }, {});

    // Collect unique statuses from reports (case-insensitive, lowercased)
    const uniqueStatuses = Array.from(
      new Set(reports.map((r) => r.status_name?.toLowerCase()).filter(Boolean))
    );

    // Count reports by status (lowercased)
    const reportStatusCounts = reports.reduce((acc, report) => {
      const status = report.status_name?.toLowerCase();
      if (status) acc[status] = (acc[status] || 0) + 1;
      return acc;
    }, {});

    // Generate filters for reports based on unique statuses
    const generatedReportFilters = uniqueStatuses.map((status) => ({
      name: status,
      translatedName: translate(status),
      value: reportStatusCounts[status] || 0,
    }));

    setAvailableFilters((filters) =>
      filters.map((filter) => ({
        ...filter,
        value: countMap[filter.name] || 0,
      }))
    );

    setAvailableReportsFilters(generatedReportFilters);
  }, [pois, reports]);

  return (
    <div className={`flex flex-col space-y-3 ${isMobile ? 'p-6' : ''}`}>
      {!isMobile && (
        <div className="flex justify-start items-center gap-4">
          <Typography variant="bold_20">{translate('Filters')}</Typography>
          {(activeFilters?.length &&
            !(availableFilters || []).every((filter) => filter.value === 0)) >
            0 && (
              <Typography
                variant="semibold_16"
                onClick={() => clearFilters()}
                className="cursor-pointer text-gray-500 underline hover:text-gray-600"
              >
                {translate('ClearFilters')}
              </Typography>
            )}
        </div>
      )}
      {(reports.length || []) > 0 && (
        <Typography variant="bold_16">{translate('Reports')}</Typography>
      )}
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {availableReportsFilters.map((item, index) => {
          const isChecked = (activeFilters || []).some(
            (i) => i?.['status_name'] === item.name
          );

          return (
            <MyCityListItem
              key={item.name + index}
              text={`${item.translatedName} (${item.value})`}
              isChecked={isChecked}
              onClick={() => filtersChanged(item.name, 'status_name')}
            />
          );
        })}
      </div>

      <Typography variant="bold_16">
        {translate('Points of Interest')}
      </Typography>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {availableFilters
          .filter((item) => item.name !== 'REPORTS')
          .map((item, index) => {
            const isChecked = activeFilters.some(
              (i) => i.name === item.name && item.value
            );

            return (
              <MyCityListItem
                key={item.name + index}
                text={`${item.translatedName} (${item.value})`}
                isChecked={isChecked}
                disabled={item.value === 0}
                onClick={() => filtersChanged(item.name, 'name')}
              />
            );
          })}
      </div>
    </div>
  );
};

export default memo(FiltersComponent);
